import { beveledBox } from '../geometry/beveledBox.js';

/** Finish architectural masses before static batching, identically in /models.
 * Thin glazing, signs, small props and custom silhouettes retain their geometry.
 * Bounds/material slots stay intact, including textured walls and roof caps.
 */
export function finishBuilding(group) {
  const replacements = new Map();
  group.traverse(mesh => {
    if (!mesh.isMesh || mesh.isInstancedMesh) return;
    const geo = mesh.geometry;
    if (geo.type !== 'BoxGeometry') return;
    const { width: w, height: h, depth: d } = geo.parameters;
    if (Math.min(w, h, d) < 0.35 || Math.max(w, h, d) < 2) return;
    const materials = [].concat(mesh.material);
    if (materials.some(m => m.transparent || m.isMeshBasicMaterial)) return;
    // Do not replace boxes whose vertices were transformed inside the builder.
    geo.computeBoundingBox();
    const { min, max } = geo.boundingBox;
    if ([min.x + w / 2, max.x - w / 2, min.y + h / 2, max.y - h / 2,
      min.z + d / 2, max.z - d / 2].some(v => Math.abs(v) > 1e-5)) return;
    if (!replacements.has(geo)) replacements.set(geo, beveledBox(w, h, d, Math.min(0.14, Math.min(w, h, d) * 0.16)));
    mesh.geometry = replacements.get(geo);
  });
  return group;
}
